/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const verifyMyEmailBodyTwoCodeRegExp = new RegExp('^\\d{6}$');

export const VerifyMyEmailBody = zod
  .object({
    csrfToken: zod.string(),
    email: zod.email(),
    expiresAt: zod.string(),
    flowId: zod.string().min(1),
  })
  .describe(
    'Verification flow state to echo back on \/me\/emails\/verify. Absent when the OTP email could not be dispatched (the address was still added; use \/me\/emails\/resend).',
  )
  .and(
    zod.object({
      code: zod.string().regex(verifyMyEmailBodyTwoCodeRegExp),
    }),
  );

export type VerifyMyEmailBody = zod.input<typeof VerifyMyEmailBody>;
export type VerifyMyEmailBodyOutput = zod.output<typeof VerifyMyEmailBody>;
